// extracted by mini-css-extract-plugin
module.exports = {"pretitle":"R6UWh","image-wrapper":"tEmPw","card":"C5VLo","card__pretitle":"Pfmju","card__title":"DyIze","card__body":"js1Ey","card--first":"g1ukL","card__button":"-x+EM"};